import Component from '../../js/_Component';

export default class Pagination extends Component {
	/**
	 * Current page number, 1 indexed.
	 */
	private current: number;

	/**
	 * The URL to use for pages.
	 */
	private action: string;

	/**
	 * The parameter name.
	 */
	private param: string;

	private static readonly RANGE = 2;

	constructor(element: HTMLElement) {
		super(element);

		this.current = parseInt(this.element.dataset['current']);
		this.action = this.element.dataset['action'] || `${window.location}`;
		this.param = this.element.dataset['param'];

		this.setMaxPages(parseInt(this.element.dataset['max']) || null);
	}

	setMaxPages(amount: number) {
		// Amount must be specified and larger than one page.
		if (amount !== null && amount > 1) {
			const template = this.element.querySelector(':scope > template') as HTMLTemplateElement;

			const firstPageButton = Math.max(
				1,
				Math.min(this.current - Pagination.RANGE, amount - Pagination.RANGE * 2),
			);

			const lastPageButton = Math.min(
				amount,
				Math.max(this.current + Pagination.RANGE, 1 + Pagination.RANGE * 2),
			);

			// Show ellipsis and first page buttons if the first page in range is not the beginning.
			if (firstPageButton !== 1) {
				this.element.querySelector('.c-pagination--ellipsis.m-before').classList.remove('m-hidden');
				this.setButtonAction(this.element.querySelector('.c-pagination--page-button.m-first') as HTMLAnchorElement, 1);
			}

			const lastEllipsis = this.element.querySelector('.c-pagination--ellipsis.m-after');

			// Create buttons up to 3 pages on either side of the current page.
			for (let i = firstPageButton; i <= lastPageButton; i += 1) {
				const clonedFragment = document.importNode(template.content, true);
				const button = clonedFragment.querySelector('.c-pagination--page-button') as HTMLAnchorElement;
				button.textContent = `${i}`;
				this.setButtonAction(button, i);
				lastEllipsis.parentElement.insertBefore(clonedFragment, lastEllipsis);
			}

			// Show ellipsis and last page buttons if the last page in range is not the end.
			if (lastPageButton !== amount) {
				lastEllipsis.classList.remove('m-hidden');
				this.setButtonAction(this.element.querySelector('.c-pagination--page-button.m-last') as HTMLAnchorElement, amount);
			}
		}
	}

	/**
	 * Determines the action URL for an anchor, and unhides it, if needed.
	 * @param button The button to set the URL for.
	 * @param index The page the button should link to.
	 */
	private setButtonAction(button: HTMLAnchorElement, index: number) {
		const url = new URL(this.action);
		url.searchParams.set(this.param, `${index}`);
		button.href = `${url}`;
		if (index === this.current) {
			button.classList.add('m-current');
		}
		button.classList.remove('m-hidden');
	}
}

Component.register(Pagination, 'Pagination');
